import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import ProofStrip from './components/ProofStrip';
import Services from './components/Services';
import Approach from './components/Approach';
import Results from './components/Results';
import Contact from './components/Contact';
import Policy from './components/Policy';
import Footer from './components/Footer';
import './App.css';

function Home() {
  return (
    <>
      <Hero />
      <ProofStrip />
      <Services />
      <Approach />
      <Results />
      <Contact />
    </>
  );
}

function App() {
  return (
    <HashRouter>
      <MotionConfig reducedMotion="user">
        <div className="site">
          <a
            className="skip-link"
            href="#main"
            onClick={(event) => {
              event.preventDefault();
              document.getElementById('main')?.focus();
            }}
          >
            Skip to content
          </a>
          <Header />
          <main id="main" tabIndex={-1}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/policy" element={<Policy />} />
              <Route path="/privacy" element={<Policy />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </MotionConfig>
    </HashRouter>
  );
}

export default App;
